(function () {
  const AVAILABILITY_KEY = 'filter.v.availability';
  const AVAILABILITY_VALUE = '1';

  function getURL() {
    return new URL(window.location.href);
  }

  function hasRealFilters(params) {
    return [...params.keys()].some((key) => {
      if (key === AVAILABILITY_KEY) return false;
      return key.startsWith('filter.');
    });
  }

  function normalize(url) {
    const params = url.searchParams;
    const hasFilters = hasRealFilters(params);

    if (hasFilters) {
      params.set(AVAILABILITY_KEY, AVAILABILITY_VALUE);
    } else {
      params.delete(AVAILABILITY_KEY);
    }

    return url;
  }

  function apply() {
    const current = getURL();
    const normalized = normalize(new URL(current));

    if (normalized.toString() !== current.toString()) {
      window.location.replace(normalized.toString());
    }
  }

  /* ---------------- INIT ---------------- */

  function bind() {
    apply();

    // back/forward
    window.addEventListener('popstate', apply);

    // Shopify dynamic reloads
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('filter:update', () => {
        requestAnimationFrame(apply);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();